import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import {
  emptyTokenSavingsSummary,
  tokenSavingsQueryKey,
  tokenSavingsService,
  type TokenSavingsRange,
  type TokenSavingsSummary,
} from "@/services/tokenSavingsService";

export function useTokenSavings(range: TokenSavingsRange = "all") {
  const { user } = useAuth();
  return useQuery<TokenSavingsSummary>({
    queryKey: tokenSavingsQueryKey(user?.id, range),
    enabled: Boolean(user?.id),
    staleTime: 30_000,
    refetchOnMount: true,
    queryFn: () => tokenSavingsService.getSummary(user!.id, range),
    placeholderData: emptyTokenSavingsSummary(range),
  });
}
